import React, { useState } from "react";
import RecommendTab from "./recommend_tab";
import ChildCircleTab from "./child_circle_tab";
import TalkroomTab from "./talkroom_tab";

const Profile = ({ circleId, blogs, events, child_circles, userSignedIn, isCircleMember, myFollowingFutureEventIds, albums, usersCircles, circleName, currentUser, companyId, hashedCompanyId, isOshikatsu }) => {
  const [childCircles, setChildCircles] = useState(child_circles || []);
  const [circleData] = useState({
    recommend: {circleId, blogs, events, userSignedIn, isCircleMember, myFollowingFutureEventIds, albums, circleName, companyId, hashedCompanyId, isOshikatsu} || [],
    child_circle: {child_circles: childCircles, isCircleMember, usersCircles} || [],
    talkroom: {currentUser, companyId, hashedCompanyId, circleId } || [],  
  });

  const isServer = typeof window === "undefined" || typeof localStorage === "undefined";
  const canShowTalkroom = !!companyId;
  const [activeTab, setActiveTab] = useState(() => {
    if (isServer) {
      return "recommend-tab";
    } else {
      const savedTab = localStorage.getItem("activeTab") || "recommend-tab";
      if(savedTab === "child_circle-tab" && !canShowChildCircle) {
        return "recommend-tab";
      }
      if(savedTab === "talkroom-tab" && !canShowTalkroom) {
        return "recommend-tab";
      }
      return ["recommend-tab", "child_circle-tab", "talkroom-tab"].includes(savedTab)
        ? savedTab
        : "recommend-tab";
    }
  });

  const canShowChildCircle = isOshikatsu === true;
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (!isServer) {
      localStorage.setItem("activeTab", tab);
    }
  };

  if ((!isCircleMember && !companyId) || (!isOshikatsu && !companyId)) {
    return (
      <div className="container">
        <div className="tab-content">
          <RecommendTab data={circleData.recommend} />
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      {/* トグルバー */}
      <div className="container mt-3 d-flex justify-content-center align-items-center">
        <div className="col-lg-8 toggle-bar d-flex justify-content-center align-items-center">
          <button
            className={`btn btn-circle-toggle ${
              activeTab === "recommend-tab" ? "active" : ""
            }`}
            id="recommend-tab"
            style={{
              flex: 1,
              borderRadius: "30px 0 0 30px",
              fontWeight: activeTab === "recommend-tab" ? "bold" : "normal",
            }}
            onClick={() => handleTabClick("recommend-tab")}
          >
            イベントページ
          </button>
          {canShowChildCircle && (
          <button
              className={`btn btn-circle-toggle ${
                activeTab === "child_circle-tab" ? "active" : ""
              }`}
              id="child_circle-tab"
              style={{
                flex: 1,
                fontWeight: activeTab === "child_circle-tab" ? "bold" : "normal",
              }}
              onClick={() => handleTabClick("child_circle-tab")}
            >
              子サークル
            </button>
          )}
          {companyId && (
            <button
              className={`btn btn-circle-toggle ${activeTab === "talkroom-tab" ? "active" : ""}`}
              id="talkroom-tab"
              style={{
                flex: 1,
                borderRadius: canShowChildCircle ? "0 30px 30px 0" : "0 30px 30px 0",
                fontWeight: activeTab === "talkroom-tab" ? "bold" : "normal",
              }}
              onClick={() => handleTabClick("talkroom-tab")}
            >
              トークルーム
            </button>
          )}
        </div>
      </div>
      <div className="tab-content">
        {activeTab === "recommend-tab" && (
          <RecommendTab data={circleData.recommend} />
        )}
        {canShowChildCircle && activeTab === "child_circle-tab" && (
          <ChildCircleTab data={circleData.child_circle} setChildCircles={setChildCircles} circleId={circleId} isCircleMember={isCircleMember}/>
        )}
        {activeTab === "talkroom-tab" && (
          <TalkroomTab data={circleData.talkroom} />
        )}
      </div>
    </div>
  );
};

export default Profile;
